import { useEffect, useState } from "react";
import "./MobileBets.css";
import dolat_img from "../../../public/dolar.svg";
import { IoMdClose } from "react-icons/io";
import { fetchBets } from "../../../../AsianExchangeSrc/redux/slices/betsSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserId,
  getUserLoggedInType,
} from "../../../../AsianExchangeSrc/utils/helper/commonSelectors";

const MobileBets = ({ openSide, closeBets }) => {
  const dispatch = useDispatch();
  const [isSubVisible, setIsSubVisible] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const { bets } = useSelector((state) => state.bets);
  const userId = useSelector(getUserId());
  const loggedInUserType = useSelector(getUserLoggedInType());

  console.log({ bets });

  useEffect(() => {
    if (!userId) return;

    const interval = setInterval(() => {
      if (loggedInUserType === "real") {
        dispatch(fetchBets());
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [dispatch, userId]);

  const radioOptions = ["Bet Info", "Time Order", "Average Odds"];

  const handleListClick = (match) => {
    setSelectedMatch(match);
    setIsSubVisible(true);
  };

  const handleGoBack = () => {
    setIsSubVisible(false);
    setSelectedMatch(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  return (
    <>
      <div className={`OpenBets_main ${openSide}`}>
        <div className="OpenBets_header">
          <div className="OpenBets_image">
            <img src={dolat_img} alt="" />
            <h4>Open Bets </h4>
          </div>
          <div className="close-bets" onClick={closeBets}>
            <IoMdClose />
          </div>
        </div>

        {!isSubVisible && (
          <ul>
            {bets?.map((match, i) => (
              <li key={i} onClick={() => handleListClick(match)}>
                {match.event}
              </li>
            ))}
          </ul>
        )}

        {isSubVisible && selectedMatch && (
          <div className="OpenBets-sub">
            <div className="pathWrap">
              <div className="goBack" onClick={handleGoBack}></div>
              <p>{selectedMatch.event}</p>
            </div>
            <div className="match-header">
              <p>Matched</p>
            </div>

            <div className="bet-card-container">
              <div className="bet-card-header">
                <p style={{ width: "63%" }}>{selectedMatch.type}</p>
                <div className="bet-card-details">
                  <span className="bet-card-odds px-0.5 w-1/3">Odds</span>
                  <span className="bet-card-stake px-0.5 w-1/3">Stake</span>
                  <span className="bet-card-profit px-0.5 w-1/3">Profit</span>
                </div>
              </div>
              <div
                className="bet-info"
                style={
                  selectedMatch.type === "Lay"
                    ? {
                        backgroundColor: "#f7e7eb",
                      }
                    : {}
                }
              >
                <p>Ref: {selectedMatch.matchId}</p>
                <p>{formatDate(selectedMatch.placeTime)}</p>
              </div>
              <div
                className="bet-card-info-row"
                style={
                  selectedMatch.type === "Lay"
                    ? {
                        backgroundColor: "#f3dce2",
                        borderBottom: "1px solid #d38e9c",
                      }
                    : {}
                }
              >
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    width: "63%",
                  }}
                >
                  <button
                    className="bet-card-back-button"
                    style={
                      selectedMatch.type === "Lay"
                        ? {
                            backgroundColor: "#faa9ba",
                          }
                        : {}
                    }
                  >
                    {selectedMatch.type}
                  </button>
                  <span className="bet-card-team-name">
                    {selectedMatch.selection}
                  </span>
                </div>

                <div className="bet-ods">
                  <span className="bet-card-info-value text-[12px] px-0.5 w-1/3">
                    {selectedMatch?.oddsReq != null
                      ? selectedMatch.oddsReq
                      : `${selectedMatch.price}/${selectedMatch.size}`}
                  </span>

                  <span className="bet-card-info-value text-[12px] px-0.5 w-1/3">
                    {selectedMatch?.stake?.toFixed(2)}
                  </span>
                  <span className="bet-card-info-value text-[12px] px-0.5 w-1/3">
                    {selectedMatch?.favourMargin?.toFixed(2)}
                  </span>
                </div>
              </div>
              <div className="bet-card-options">
                {radioOptions?.map((option, index) => (
                  <label className="bet-card-option" key={index}>
                    <input type="radio" name="bet-option" />
                    {option}
                  </label>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MobileBets;
